import { styled } from '@mui/system';
import { COLORS } from '../../styles/constants';

export const StyledLink = styled('a')(({ theme, color }) => ({
	color: color || COLORS.LINK,
	textDecoration: 'none',
	'&:hover': {
		cursor: 'pointer',
		textDecoration: 'underline'
	}
}));
